import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getValueByPath } from '../../../helpers/getValueByPath';
import { setMapForFilterQuery } from '../helpers/setMapForFilterQuery';

const useFilterItemsWithAmount = ({
  data,
  requestKey,
  notIndicated,
  needSort = true,
  customSort = false,
  customSortFn,
}) => {
  const [itemsMap, setItemsMap] = useState(new Map());
  const [items, setItems] = useState([]);

  const filteredRequests = useSelector(
    (state) => state.statisticsStore.filteredRequests
  );

  useEffect(() => {
    const map = data?.length
      ? setMapForFilterQuery(data, notIndicated)
      : new Map();

    if (filteredRequests?.length) {
      filteredRequests.forEach((request) => {
        const key = getValueByPath(request, requestKey) ?? 0;

        const item = map.get(key);

        if (item) {
          map.set(key, {
            ...item,
            amount: item.amount + 1,
          });
        }
      });
    }

    const items = Array.from(map.values()).filter((item) => item.amount !== 0);

    if (customSort && typeof customSortFn === 'function') {
      items.sort(customSortFn);
    } else if (needSort) {
      items.sort((a, b) => b.amount - a.amount);
    }

    setItemsMap(map);
    setItems(items);
  }, [data, filteredRequests]);

  return { items, itemsMap };
};

export default useFilterItemsWithAmount;
